import { render, staticRenderFns } from "./FormThuxHorizontalCKEditor.vue?vue&type=template&id=4c7376f7&"
import script from "./FormThuxHorizontalCKEditor.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalCKEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports